import { render, staticRenderFns } from "./Characters.vue?vue&type=template&id=7dc80cd6&scoped=true"
import script from "./Characters.vue?vue&type=script&lang=js"
export * from "./Characters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc80cd6",
  null
  
)

export default component.exports